import styled from "styled-components";

export const PrimaryButton = styled.button`
  height: auto;
  padding: 10px 30px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  background-image: linear-gradient(to right, #1e7dde, #00c4c4);
  box-shadow: none;
  color: white !important;
  border: none;
  text-align: center;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    background-image: linear-gradient(to right, #1e7dde, #00c4c4);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }
  &:active,
  &:focus {
    /* TODO(KentoMoriwaki): Apply active style */
    background-image: linear-gradient(to right, #1e7dde, #00c4c4);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
    outline: none;
  }
`;

export const LinkButton = styled.button`
  height: auto;
  padding: 0px;
  border-radius: 100px;
  border: none;
  font-size: 13px;
  font-weight: 300;
  line-height: 1;
  background: none;
  box-shadow: none;
  text-align: center;
  color: rgba(0, 0, 0, 0.4);
  &:hover {
    background: none;
    box-shadow: none;
    text-decoration: underline;
  }
  &:active,
  &:focus {
    /* TODO(KentoMoriwaki): Apply active style */
    outline: none;
  }
`;



// WEBPACK FOOTER //
// ./frontend/src/common/components/buttons/index.tsx